import { render, staticRenderFns } from "./TerminologyPageLink.vue?vue&type=template&id=b48d20a0"
import script from "./TerminologyPageLink.vue?vue&type=script&lang=js"
export * from "./TerminologyPageLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_qfdn4gbztslujeagaknuyibsmy/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports